import { Injectable, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@jsverse/transloco";

// Class to handle matpaginator translations
@Injectable()
export class ItMatPaginatorIntl extends MatPaginatorIntl {
  private transloco = inject(TranslocoService);

  constructor() {
    super();
    this.setTranslations();
    this.transloco.langChanges$.subscribe(() => {
      this.setTranslations();
      this.changes.next();
    });
  }

  // VERSIONE ORIGINALE
  // This function handles the range label (es. "1 – 10 di 100")
  // override getRangeLabel = (page: number, pageSize: number, length: number) => {
  //  const ofLabel = 'di';
  //  if (length === 0 || pageSize === 0) {
  //      return `0 ${ofLabel} ${length}`;
  //  }
  //     length = Math.max(length, 0);
  //     const startIndex = page * pageSize;
  //     // Se l'indice di inizio supera la lunghezza, non mostriamo nulla
  //     const endIndex = startIndex < length ?
  //       Math.min(startIndex + pageSize, length) :
  //       startIndex + pageSize;
  //     return `${startIndex + 1} – ${endIndex} ${ofLabel} ${length}`;
  //   };

  // FIX TEMPORANEO PER NON MOSTRARE TOTALE (es. "1 – 10")
  // override getRangeLabel = (page: number, pageSize: number, length: number) => {
  //   if (length === 0 || pageSize === 0) {
  //     return '0';
  //   }

  //   length = Math.max(length, 0);
  //   const startIndex = page * pageSize;

  //   // Se l'indice di inizio supera la lunghezza, non mostriamo nulla
  //   const endIndex = startIndex < length
  //     ? Math.min(startIndex + pageSize, length)
  //     : startIndex + pageSize;

  //   return `${startIndex + 1} - ${endIndex}`;
  // };

  //  FIX TEMPORANEO NUMERO PAGINE (es. "Pagina 1 di 10")
  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    const pageLabel = this.transloco.translate('paginator.page');
    const ofLabel = this.transloco.translate('paginator.of');

    if (length === 0 || pageSize === 0) {
      return `${pageLabel} 0 ${ofLabel} 0`;
    }
  
    length = Math.max(length, 0);
    const currentPage = page + 1;
    const totalPages = Math.ceil(length / pageSize);
  
    return `${pageLabel} ${currentPage} ${ofLabel} ${totalPages}`;
  };

  private setTranslations(): void {
    this.itemsPerPageLabel = this.transloco.translate('paginator.itemsPerPageLabel');
    this.nextPageLabel = this.transloco.translate('paginator.nextPageLabel');
    this.previousPageLabel = this.transloco.translate('paginator.previousPageLabel');
    this.firstPageLabel = this.transloco.translate('paginator.firstPageLabel');
    this.lastPageLabel = this.transloco.translate('paginator.lastPageLabel');
  }
}

//TODO: nel caso si decidesse di usare la funzione
// export function getItPaginatorIntl() {
//   const paginatorIntl = new MatPaginatorIntl();
  
//   // TODO: read from correct localiziation
//   paginatorIntl.itemsPerPageLabel = 'Elementi per pagina:';
//   paginatorIntl.nextPageLabel = 'Pagina successiva';
//   paginatorIntl.previousPageLabel = 'Pagina precedente';
//   paginatorIntl.firstPageLabel = 'Prima pagina';
//   paginatorIntl.lastPageLabel = 'Ultima pagina';
  
//   // This function handles the range label (es. "1 – 10 di 100")
//   paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
//     const label = 'di';

//     if (length === 0 || pageSize === 0) {
//       return `0 ${label} ${length}`;
//     }
//     length = Math.max(length, 0);
//     const startIndex = page * pageSize;
//     // Se l'indice di inizio supera la lunghezza, non mostriamo nulla
//     const endIndex = startIndex < length ?
//       Math.min(startIndex + pageSize, length) :
//       startIndex + pageSize;
//     return `${startIndex + 1} – ${endIndex} ${label} ${length}`;
//   };

//   return paginatorIntl;
// }
